export default __webpack_public_path__ + "static/media/icon_arrow.5a2e0b83.svg";